export const optionTableUser = {
  headerStyle: {
    backgroundColor: "#0074d9",
    color: "#FFF",
    width: 150,
    minWidth: 150,
    textAlign: "center",
  },
  rowStyle: {
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  cellStyle: (rowData) => ({
    width: 150,
    minWidth: 150,
    textAlign: "center",
    backgroundColor:
      rowData === "Worker"
        ? "#fd7e14"
        : rowData === "Planner"
        ? "#6f42c1"
        : "#EEE",
    color: rowData === "Worker" || rowData === "Planner" ? "white" : "black",
  }),
  filtering: true,
  actionsColumnIndex: -1,
  search: false,
  sorting: true,
  emptyRowsWhenPaging: true,
};

export const optionTableProject = {
  headerStyle: {
    backgroundColor: "#0074d9",
    color: "#FFF",
    width: 150,
    minWidth: 150,
    textAlign: "center",
  },
  rowStyle: {
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  cellStyle: (rowData) => ({
    width: 150,
    minWidth: 150,
    textAlign: "center",
    backgroundColor:
      rowData === "Approve"
        ? "#28a745"
        : rowData === "Reject"
        ? "#dc3545"
        : rowData === "Return"
        ? "#ffc107"
        : rowData === "Submit"
        ? "#007bff"
        : "#EEE",
    color:
      rowData === "Approve" ||
      rowData === "Reject" ||
      rowData === "Return" ||
      rowData === "Submit"
        ? "white"
        : "black",
  }),
  filtering: true,
  actionsColumnIndex: -1,
  search: false,
  sorting: true,
  emptyRowsWhenPaging: true,
};

export const optionTableTask = {
  headerStyle: {
    backgroundColor: "#0074d9",
    color: "#FFF",
    width: 150,
    minWidth: 150,
    textAlign: "center",
  },
  rowStyle: {
    backgroundColor: "#EEE",
    textAlign: "center",
  },
  cellStyle: (rowData) => ({
    width: 150,
    minWidth: 150,
    textAlign: "center",
    backgroundColor:
      rowData === "Done"
        ? "#28a745"
        : rowData === "Complete"
        ? "#17a2b8"
        : rowData === "Return to Worker"
        ? "#ffc107"
        : "#EEE",
    color:
      rowData === "Done" ||
      rowData === "Complete" ||
      rowData === "Return to Worker"
        ? "white"
        : "black",
  }),
  filtering: true,
  actionsColumnIndex: -1,
  search: false,
  sorting: true,
  emptyRowsWhenPaging: true,
};
